/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.edit.controllers', [
  'ui.bootstrap',
  'acme.common.factory.notice',
  'acme.common.service.api',
  'acme.common.service.auth',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.common.service.order',
  'acme.common.service.order',
  'acme.common.service.templates.helpers',
  'acme.common.service.calendar',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.orders.requests.modals.tickets.controllers',
  'acme.view.application.orders.requests.modals.scheduleEvent.controllers',
  'acme.view.application.orders.requests.modals.removeEvent.controllers',
  'acme.view.application.orders.requests.modals.selectResourceType.controllers',
  'acme.view.application.programs.modals.rescheduleEvent.controllers'
])

.controller('OrdersRequestsEditController',
  [ '$q',
    '$uibModal',
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    'OrderData',
    'NoticeFactory',
    'ApiService',
    'HelpersService',
    'GridStateFactory',
    'GridDefinitionFactory',
    'PermissionsService',
    'AuthService',
    'OrderService',
    'CustomFieldsData',
    'UserPreferencesService',
    'CalendarService',
    'TemplatesHelpersService',
    function($q,
             $uibModal,
             $scope,
             $state,
             $filter,
             $timeout,
             OrderData,
             NoticeFactory,
             ApiService,
             HelpersService,
             GridStateFactory,
             GridDefinitionFactory,
             PermissionsService,
             AuthService,
             OrderService,
             CustomFieldsData,
             UserPreferencesService,
             CalendarService,
             TemplatesHelpersService) {

    $scope.ordersRequestsEdit = {

      mode: 'create',

      reduceList: false,

      model: {
        orderRequestItems: [],
        orderRequestStatus: 'OPEN',
        payment: {
          status: 'NO_ORDERS_YET'
        }
      },

      queryTimer: false,

      unscheduledEvents: [],
      unscheduledEventsSummary: {
        total: 0,
        tickets: 0,
        addons: 0,
        quantity: 0
      },
      scheduledEvents: [],
      scheduledEventsSummary: {
        total: 0,
        tickets: 0,
        addons: 0,
        quantity: 0
      },
      purchasedEvents: [],
      purchasedEventsSummary: {
        total: 0,
        tickets: 0,
        addons: 0,
        quantity: 0
      },
      selectedEvents: {},

      selectedStatus: 'OPEN',
      totalTickets: 0,
      totalAddons: 0,

      shortDateTime: HelpersService.dateFormats.sortDateTime,

      timeStampDateFormat: UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat'),
      timeStampHourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('shortDateTime'),

      statusTypes: [
        {
          label: 'Open',
          value: 'OPEN'
        },
        {
          label: 'Complete',
          value: 'COMPLETE'
        },
        {
          label: 'Cancelled',
          value: 'CANCELLED'
        }
      ],

      paymentStatusTypes: [
        { value: 'NO_ORDERS_YET',
          label: 'No orders yet'
        },
        { value: 'NOT_PAID',
          label: 'Not Paid'
        },
        { value: 'PARTIALLY_PAID',
          label: 'Partially paid'
        },
        { value: 'PAID_IN_FULL',
          label: 'Paid in full'
        },
        { value: 'REFUNDED',
          label: 'Refunded'
        }
      ],

      eventStateTypes: [
        {
          label: 'Deleted',
          value: 'deleted'
        },
        {
          label: 'Active',
          value: 'active'
        },
        {
          label: 'Cancelled',
          value: 'cancelled'
        }
      ],

      users: [],
      organizationContacts: [],
      selectedOrderContact: false,

      searchingOrganizations: false,
      selectedOrganization: '',
      currentOrganization: '',
      lastSearchQueryOrganizations: '',
      organizationsGridState: new GridStateFactory(),
      organizationsPageSize: 10,

      searchingUsers: false,
      selectedInternalContact: '',
      currentInternalContact: '',
      lastSearchQueryUsers: '',
      usersGridState: new GridStateFactory(),
      usersPageSize: 5,

      isRestrictedUser: false,

      isTaxExempt: false,

      organizations: [],

      notice: new NoticeFactory(),

      unscheduledEventsGridDefinition: new GridDefinitionFactory(),
      scheduledEventsGridDefinition: new GridDefinitionFactory(),
      purchasedEventsGridDefinition: new GridDefinitionFactory(),

      viewId: '',
      ordersRequestsUnscheduledEventsGridName: $state.current.name+'.grid0',
      ordersRequestsScheduledEventsGridName: $state.current.name+'.grid1',
      ordersRequestsPurchasedEventsGridName: $state.current.name+'.grid2',

      customFields: [],

      //org combobox
      comboboxOrganizations: [],
      comboboxSelectedOrganization: '',
      
      waitTime: 500,

      optionsOverride: {
        useExternalPagination: false,
        useExternalSorting: false,
        enablePagination: false,
        enableRowSelection: true,
        showGridFooter: false,
        useAccessibleGrid: true,
        multiSelect: true,
        noUnselect: false,
        appScopeProvider: {
          onDataGridSelectionChange: function (row, e) {
            $scope.ordersRequestsEdit.onDataGridSelectionChange(row, e);
          },
          onShowScheduleEventModal: function (row, e) {
            $scope.ordersRequestsEdit.showScheduleEventModal(row, 'scheduled');
          },

          onShowRescheduleEventModal: function (row, e) {
            $scope.ordersRequestsEdit.showRescheduleEventModal(row);
          },

          onCreateEventModal: function (row, e) {
            $scope.ordersRequestsEdit.showScheduleEventModal(row, 'unscheduled');
          },

          onViewEvent: function (row, e) {
            $scope.ordersRequestsEdit.viewEvent(row, e);
          },

          onViewEventTemplate: function (row, e) {
            $scope.ordersRequestsEdit.viewEventTemplate(row, e);
          },

          onShowTicketsModal: function (row, e) {
            $scope.ordersRequestsEdit.showTicketsModal(row, 'scheduled');
          },

          onShowTemplateTicketsModal: function (row, e) {
            $scope.ordersRequestsEdit.showTicketsModal(row, 'unscheduled');
          },

          onAssignResource: function (row, e) {
            if (row.entity.isSelfAssign) {
              $scope.ordersRequestsEdit.assignResource(row, e);
            }else {
              $scope.ordersRequestsEdit.viewEvent(row, e);
            }
          },

          onViewOrder: function (row, e) {
            $scope.ordersRequestsEdit.viewOrder(row, e);

          },
          
          findPaymentStatus: function (status) {
            return $scope.ordersRequestsEdit.findPaymentStatus(status);
          },

          findEventState: function (state) {
            return $scope.ordersRequestsEdit.findEventState(state);
          },

          onAfterCellEdit: function(row, e) {
            $scope.ordersRequestsEdit.onExternalReferenceIdEdited(row);
          }
        }
      },

      unscheduledEventsOptions: {
        data: 'ordersRequestsEdit.unscheduledEvents',
        columnDefs: [
          {
            field: 'eventTemplateName',
            displayName: 'Event Name',
            visible: true,
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onViewEventTemplate(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="row.entity.colorCategoryStyle"></span> <a data-ng-click="grid.appScope.onViewEventTemplate(row)">{{ row.entity.eventTemplateName }}</a></div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.eventTemplateName) {
                r = '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="' + params.data.colorCategoryStyle + '"></span><a>'+ params.data.eventTemplateName +'</a></div>';
              }

              return r;
            }
          },
          {
            field: 'ticketsDisplay',
            displayName: 'Tickets',
            visible: true,
            minWidth: 150,
            colId: 'tickets',
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onShowTemplateTicketsModal(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" data-ng-if="row.entity.allowTicketEdit">' +
                            '<a data-ng-click="grid.appScope.onShowTemplateTicketsModal(row)">' +
                              '<span data-ng-if="row.entity.ticketsDisplay">{{ row.entity.ticketsDisplay }}</span>' +
                              '<span data-ng-if="!row.entity.ticketsDisplay">Add Tickets</span>' +
                            '</a>' +
                          '</div>' +
                          '<div class="ui-grid-cell-contents" data-ng-if="!row.entity.allowTicketEdit">' +
                            '<span data-ng-if="row.entity.ticketsDisplay">{{ row.entity.ticketsDisplay }}</span>' +
                            '<span data-ng-if="!row.entity.ticketsDisplay">No Tickets</span>' +
                          '</div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.allowTicketEdit) {
                if (params.data.ticketsDisplay) {
                  r = '<div class="clickable ui-grid-cell-contents"><a>'+ params.data.ticketsDisplay +'</a></div>';
                } else {
                  r = '<div class="clickable ui-grid-cell-contents"><a>Add Tickets</a></div>';
                }
              } else {
                if (params.data.ticketsDisplay) {
                  r = '<div class="ui-grid-cell-contents">' + params.data.ticketsDisplay + '</div>';
                } else {
                  r = '<div class="ui-grid-cell-contents">No Tickets</div>';
                }
              }

              return r;
            }
          },
          {
            field: 'subTotal',
            displayName: 'Total',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (COL_FIELD || 0) | currency }}</div>',
            cellRenderer: function(params) {
              return $filter('currency')(params.data.subTotal || 0);
            },
            visible: true
          },
          {
            field: 'externalReferenceId',
            displayName: 'External Reference ID',
            visible: true,
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            cellEditableCondition: function() {
              return !$scope.ordersRequestsEdit.isRestrictedUser;
            },
            editable: function () {
              return !$scope.ordersRequestsEdit.isRestrictedUser;
            },
            enableCellEdit: true,
            enableCellEditOnFocus: true
          }
        ]
      },

      scheduledEventsOptions: {
        data: 'ordersRequestsEdit.scheduledEvents',
        columnDefs: [
          {
            field: 'eventName',
            displayName: 'Event Name',
            visible: true,
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onViewEvent(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="row.entity.colorCategoryStyle"></span> <a data-ng-click="grid.appScope.onViewEvent(row)">{{ row.entity.eventName }}</a></div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.eventName) {
                r = '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="' + params.data.colorCategoryStyle + '"></span> <a>'+ params.data.eventName +'</a></div>';
              }

              return r;
            }
          },
          {
            field: 'resourceRequestDisplay',
            displayName: 'Resources',
            visible: true,
            minWidth: 150,
            colId: 'resourceRequestSummary',
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onAssignResource(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents">' +
                            '<a data-ng-click="grid.appScope.onAssignResource(row)">' +
                              '<span data-ng-if="row.entity.resourceRequestDisplay && !row.entity.isSelfAssign">{{ row.entity.resourceRequestDisplay }}</span>' +
                              '<span data-ng-if="!row.entity.resourceRequestDisplay && !row.entity.isSelfAssign">Add Resource <span class="fa fa-angle-right"></span></span>' +
                              '<span data-ng-if="row.entity.isSelfAssign">Assign to me</span>' +
                            '</a>' +
                          '</div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.resourceRequestDisplay) {
                r = '<div class="clickable ui-grid-cell-contents"><a>'+ params.data.resourceRequestDisplay +'</a></div>';
              } else {
                if (!row.entity.isSelfAssign) {
                  r = '<div class="clickable ui-grid-cell-contents"><a>Add Resource <span class="fa fa-angle-right"></span></a></div>';
                } else {
                  r = '<div class="clickable ui-grid-cell-contents"><a>Assign to me</a></div>';
                }
              }

              return r;
            }
          },
          {
            field: 'ticketsDisplay',
            displayName: 'Tickets',
            visible: true,
            minWidth: 150,
            colId: 'tickets',
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onShowTicketsModal(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" data-ng-if="row.entity.allowTicketEdit">' +
                            '<a data-ng-click="grid.appScope.onShowTicketsModal(row)">' +
                              '<span data-ng-if="row.entity.ticketsDisplay">{{ row.entity.ticketsDisplay }}</span>' +
                              '<span data-ng-if="!row.entity.ticketsDisplay">Add Tickets</span>' +
                            '</a>' +
                          '</div>' +
                          '<div class="ui-grid-cell-contents" data-ng-if="!row.entity.allowTicketEdit">' +
                            '<span data-ng-if="row.entity.ticketsDisplay">{{ row.entity.ticketsDisplay }}</span>' +
                            '<span data-ng-if="!row.entity.ticketsDisplay">No Tickets</span>' +
                          '</div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.allowTicketEdit) {
                if (params.data.ticketsDisplay) {
                  r = '<div class="clickable ui-grid-cell-contents"><a>'+ params.data.ticketsDisplay +'</a></div>';
                } else {
                  r = '<div class="clickable ui-grid-cell-contents"><a>Add Tickets</a></div>';
                }
              } else {
                if (params.data.ticketsDisplay) {
                  r = '<div class="ui-grid-cell-contents">' + params.data.ticketsDisplay + '</div>';
                } else {
                  r = '<div class="ui-grid-cell-contents">No Tickets</div>';
                }
              }

              return r;
            }
          },
          {
            field: 'subTotal',
            displayName: 'Total',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (COL_FIELD || 0) | currency }}</div>',
            cellRenderer: function(params) {
              return $filter('currency')(params.data.subTotal || 0);
            },
            visible: true
          },
          {
            field: 'externalReferenceId',
            displayName: 'External Reference ID',
            visible: true,
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            cellEditableCondition: function() {
              return !$scope.ordersRequestsEdit.isRestrictedUser;
            },
            editable: function () {
              return !$scope.ordersRequestsEdit.isRestrictedUser;
            },
            enableCellEdit: true,
            enableCellEditOnFocus: true
          }
        ]
      },

      purchasedEventsOptions: {
        multiSelect: false,
        useAccessibleGrid: true,
        data: 'ordersRequestsEdit.purchasedEvents',
        columnDefs: [
          {
            field: 'eventName',
            displayName: 'Event Name',
            visible: true,
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onViewEvent(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="row.entity.colorCategoryStyle"></span> <a data-ng-click="grid.appScope.onViewEvent(row)">{{ row.entity.eventName }}</a></div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.eventName) {
                r = '<div class="clickable ui-grid-cell-contents orders-requests-edit-event-name"><span data-ng-style="' + params.data.colorCategoryStyle +'"></span><a>'+ params.data.eventName +'</a></div>';
              }

              return r;
            }
          },
          {
            field: 'ticketsDisplay',
            displayName: 'Tickets',
            visible: true,
            minWidth: 150,
            colId: 'tickets'
          },
          {
            field: 'subTotal',
            displayName: 'Total',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (COL_FIELD || 0) | currency }}</div>',
            cellRenderer: function(params) {
              return $filter('currency')(params.data.subTotal || 0);
            },
            visible: true
          },
          {
            field: 'balance',
            displayName: 'Balance Due',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (COL_FIELD || 0) | currency }}</div>',
            cellRenderer: function(params) {
              return $filter('currency')(params.data.balance || 0);
            },
            visible: true
          },
          {
            field: 'orderNumber',
            displayName: 'Order Number',
            onCellNavClick: function(row, col) {
              $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onViewOrder(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents"><a data-ng-if="row.entity.orderNumber" data-ng-click="grid.appScope.onViewOrder(row)">{{ row.entity.orderNumber }}</a></div>',
            cellRenderer: function(params) {
              var r = '';
              if (params.data.orderNumber) {
                r = '<div class="clickable ui-grid-cell-contents"><a>'+ params.data.orderNumber +'</a></div>';
              }

              return r;
            }
          },
          {
            field: 'externalReferenceId',
            displayName: 'External Reference ID',
            visible: true,
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            cellEditableCondition: function() {
              return PermissionsService.check('ORDER_UPDATE');
            },
            editable: function () {
              return PermissionsService.check('ORDER_UPDATE');
            },
            enableCellEdit: true,
            enableCellEditOnFocus: true
          },
          {
            field: 'orderRequestItemSummary.paymentStatus',
            displayName: 'Payment Status',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope.findPaymentStatus(COL_FIELD)) }}</div>',
            cellRenderer: function(params) {
              return $scope.ordersRequestsEdit.findPaymentStatus(params.data.paymentStatus);
            },
            visible: true,
            enableSorting: false
          },
          {
            field: 'eventState',
            displayName: 'Event State',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ (grid.appScope.findEventState(COL_FIELD)) }}</div>',
            visible: false,
            enableSorting: false
          }
        ]
      },

      init: function() {
        var titleData = {
          title: 'Edit Order Request',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              $scope.ordersRequestsEdit.cancel();
            }
          }
        };
        this.viewId = $state.current.name;

        if (CustomFieldsData.data && CustomFieldsData.data.success) {
          this.setCustomFields(CustomFieldsData);
        }

        if ($state.params.id) {
          this.mode = 'edit';

          if (OrderData.data && OrderData.data.success) {
            this.checkCurrentUserInternalContact(OrderData.data.payload);
          }

          if (!this.isRestrictedUser && !PermissionsService.check('ORDER_REQUEST_UPDATE')) {
            console.log('ORDER_REQUEST_UPDATE');
            $state.go('home.default', {}, { notify: true });
          } else if (this.isRestrictedUser){
            this.unscheduledEventsOptions.multiSelect = false;
            this.scheduledEventsOptions.multiSelect = false;
            this.purchasedEventsOptions.multiSelect = false;
          }

          this.initGridDateFormats();

          this.unscheduledEventsGridDefinition.init(this.ordersRequestsUnscheduledEventsGridName, angular.extend({}, this.optionsOverride, this.unscheduledEventsOptions), this.viewId, $state.current.data.enablePreferences);
          this.scheduledEventsGridDefinition.init(this.ordersRequestsScheduledEventsGridName, angular.extend({}, this.optionsOverride, this.scheduledEventsOptions), this.viewId, $state.current.data.enablePreferences);
          this.purchasedEventsGridDefinition.init(this.ordersRequestsPurchasedEventsGridName, angular.extend({}, this.optionsOverride, this.purchasedEventsOptions), this.viewId, $state.current.data.enablePreferences);

          if (OrderData.data && OrderData.data.success) {
            this.success.init(OrderData);
          } else {
            this.error.init(OrderData);
          }

          titleData = angular.extend(titleData, {
                            buttonRight: {
                              label: this.isRestrictedUser ? 'Done' : 'Update',
                              action: function() {
                                if ($scope.ordersRequestsEdit.isRestrictedUser) {
                                  $scope.ordersRequestsEdit.cancel();
                                }else {
                                  $scope.ordersRequestsEdit.update();
                                }
                              }
                            }});
          $scope.$emit('Application::contentTitleChange', titleData);

          if (!this.isRestrictedUser) {
            this.getOrganizationContacts(this.model.organizationId || this.model.accountId);
          }

        } else {

          if (!PermissionsService.check('ORDER_REQUEST_CREATE')) {
            console.log('ORDER_REQUEST_CREATE');
            $state.go('home.default', {}, { notify: true });
          }

          if ($state.params.orgId) {
            this.model.organizationId = $state.params.ordId;
          }

          $scope.$emit('Application::contentTitleChange', {
            title: 'Create Order Request',
            buttonLeft: {
              label: 'Cancel',
              action: function() {
                $scope.ordersRequestsEdit.cancel();
              }
            },
            buttonRight: {
              label: 'Create & Add Events',
              action: function() {
                $scope.ordersRequestsEdit.create();
              }
            }
          });

          this.getOrganizations();
          $scope.$on('$destroy', $scope.$watch('ordersRequestsEdit.selectedOrganization', this.onSelectedOrganizationChanged));
          $scope.$on('$destroy', $scope.$watch('ordersRequestsEdit.selectedInternalContact', this.onSelectedUserChanged));

        }

        if (!this.isRestrictedUser) {
          this.getUsers();
        }
      },

      initGridDateFormats: function() {
        var self = $scope.ordersRequestsEdit;

        self.unscheduledEventsOptions.columnDefs.unshift({
          field: 'eventStartDate',
          displayName: 'Date & Time',
          cellFilter: 'date: "'+ self.dateTimeFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, self.dateTimeFormat);
          },
          sort: {
            direction: 'asc'
          },
          onCellNavClick: function(row, col) {
            $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onCreateEventModal(row);
          },
          cellTemplate: '<div class="clickable ui-grid-cell-contents"><a data-ng-click="grid.appScope.onCreateEventModal(row)" role="button">Schedule Event<span class="sr-only">- Opens a dialog</span></a></div>'
        });

        self.scheduledEventsOptions.columnDefs.unshift({
          field: 'eventStartDate',
          displayName: 'Date & Time',
          sort: {
            direction: 'asc'
          },
          onCellNavClick: function(row, col) {
            $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onShowScheduleEventModal(row);
          },
          cellTemplate: '<div class="clickable ui-grid-cell-contents"><a data-ng-click="grid.appScope.onShowScheduleEventModal(row)">{{ row.entity.eventStartDate | date : "' + self.dateTimeFormat + '" }}</a></div>',
          cellRenderer: function(params) {
            var r = '';
            if (params.data.eventStartDate) {
              r = '<div class="clickable ui-grid-cell-contents"><a>'+ $filter('date')(params.data.eventStartDate, self.dateTimeFormat) +'</a></div>';
            } else {
              r = '<div class="clickable ui-grid-cell-contents"><a>Schedule Event</a></div>';
            }

            return r;
          },
          cellFilter: 'date: "'+ self.dateTimeFormat +'"'
        });

        self.purchasedEventsOptions.columnDefs.unshift(          {
          field: 'eventStartDate',
          displayName: 'Date & Time',
          cellFilter: 'date: "'+ self.dateTimeFormat +'"',
          cellFormatter: function(item) {
            return $filter('date')(item.value, self.dateTimeFormat);
          },
          sort: {
            direction: 'asc'
          },

          onCellNavClick: function(row, col) {
            $scope.ordersRequestsEdit.optionsOverride.appScopeProvider.onShowRescheduleEventModal(row);
          },
          cellTemplate: '<div class="clickable ui-grid-cell-contents"><a data-ng-click="grid.appScope.onShowRescheduleEventModal(row)">{{ row.entity.eventStartDate | date : "' + self.dateTimeFormat + '" }}</a></div>',
          cellRenderer: function(params) {
            return '<div class="clickable ui-grid-cell-contents"><a>'+ $filter('date')(params.data.eventStartDate, self.dateTimeFormat) +'</a></div>';
          }

        });
      },

      checkCurrentUserInternalContact: function(orderRequest) {
        var user = AuthService.getCookie('user');
        this.isRestrictedUser = PermissionsService.check('ORDER_REQUEST_OWNER_VIEW');
        return this.isRestrictedUser;
      },

      setCustomFields: function (customFieldsData) {
        var i, ii,
            self = $scope.ordersRequestsEdit,
            list = customFieldsData.data.payload.list,
            atIndexForUnscheduled = this.unscheduledEventsOptions.columnDefs.length,
            atIndexForScheduled = this.scheduledEventsOptions.columnDefs.length,
            atIndexForPurchased = this.purchasedEventsOptions.columnDefs.length;

        self.customFields = list;
        //ideally insert at after "scheduleName", Otherwise at end
        for (i=0,ii=this.unscheduledEventsOptions.columnDefs.length; i < ii; i++) {
          if (this.unscheduledEventsOptions.columnDefs[i].field === 'ticketsDisplay') {
            atIndexForUnscheduled = i;
            break;
          }
        }
        for (i=0,ii=this.scheduledEventsOptions.columnDefs.length; i < ii; i++) {
          if (this.scheduledEventsOptions.columnDefs[i].field === 'ticketsDisplay') {
            atIndexForScheduled = i;
            break;
          }
        }
        for (i=0,ii=this.purchasedEventsOptions.columnDefs.length; i < ii; i++) {
          if (this.purchasedEventsOptions.columnDefs[i].field === 'ticketsDisplay') {
            atIndexForPurchased = i;
            break;
          }
        }
        angular.forEach(list, function(customField, key) {
          self.unscheduledEventsOptions.columnDefs.splice(atIndexForUnscheduled, 0, {
            field: customField.internalLabel ,
            displayName: customField.label,
            visible: false,
            colId: customField.label
          });
          atIndexForUnscheduled++;
          self.scheduledEventsOptions.columnDefs.splice(atIndexForScheduled, 0, {
            field: customField.internalLabel ,
            displayName: customField.label,
            visible: false,
            colId: customField.label
          });
          atIndexForScheduled++;
          self.purchasedEventsOptions.columnDefs.splice(atIndexForPurchased, 0, {
            field: customField.internalLabel ,
            displayName: customField.label,
            visible: false,
            colId: customField.label
          });
          atIndexForPurchased++;
        });
      },

      isMode: function(mode) {
        return this.mode === mode;
      },

      getContactDisplayName: function(contact) {
        var r = '';
        if (contact) {
          if (contact.firstName) {
            r =  contact.firstName;
            if (contact.lastName) {
              r =  r + ' ' + contact.lastName;
            }
            if (contact.primary) {
              r =  r + ' (primary)';
            }
          } else if (contact.email || contact.userName) {
            r =  (contact.email || contact.userName);
          }
        }

        return r;
      },

      getUsers: function() {
        var props = this.usersGridState.getGridState(),
            search;
        this.usersGridState.updateGridState(1, this.usersPageSize, 'firstName', 'asc');

        props.role = "user";
        ApiService.userProxy.list(props).then(this.success.getUsers, this.error.getUsers);
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      filterOrganizations: function(force, field) {
        var timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.ordersRequestsEdit;

          if (force || (typeof self.selectedOrganization === 'string') && (self.lastSearchQueryOrganizations !== self.selectedOrganization)) {
            if (!force) {
              self.organizationsGridState.setPropertyValue('pageSize', self.organizationsPageSize);
            } else {
              self.organizationsGridState.setPropertyValue('pageSize', (self.organizationsGridState.gridState.pageSize + self.organizationsPageSize) );
            }
            self.organizationsGridState.gridState.search = self.hasSelectedOrganization() ? '' : self.selectedOrganization;
            self.lastSearchQueryOrganizations = self.organizationsGridState.gridState.search;
            self.searchOrganizations(field);
          }
        }, timeoutMS);
      },

      hasSelectedOrganization: function() {
        return (this.selectedOrganization && typeof this.selectedOrganization === 'object');
      },

      resetOrganizations: function() {
        var foundOrg, self = $scope.ordersRequestsEdit;
        if (self.model.organizationId) {
          foundOrg = self.findOrganization(self.model.organizationId);
        }
        $timeout(function() {
          //reset template selected if no template is chosen
          if (!self.hasSelectedOrganization()) {
            if (foundOrg || self.currentOrganization) {
              self.selectedOrganization = !foundOrg ? self.currentOrganization : self.organizations[foundOrg.index];
            }else {
              self.selectedOrganization = '';
            }
          }
          self.reduceList = false;
        },0);
      },

      searchOrganizations: function(field) {
        this.searchingOrganizations = true;
        ApiService.partners.list(this.organizationsGridState.getGridState()).then(function(response) {
          $scope.ordersRequestsEdit.success.searchOrganizations(response, field);
        }, this.error.searchOrganizations);
      },


      filterUsers: function(force, field) {
        var timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.ordersRequestsEdit;

          if (force || (typeof self.selectedInternalContact === 'string') && (self.lastSearchQueryUsers !== self.selectedInternalContact)) {
            if (!force) {
              self.usersGridState.setPropertyValue('pageSize', self.usersPageSize);
            } else {
              self.usersGridState.setPropertyValue('pageSize', (self.usersGridState.gridState.pageSize + self.usersPageSize) );
            }
            self.usersGridState.gridState.search = self.hasSelectedUser() ? '' : self.selectedInternalContact;
            self.lastSearchQueryUsers = self.usersGridState.gridState.search;
            self.searchUsers(field);
          }
        }, timeoutMS);
      },

      hasSelectedUser: function() {
        return (this.selectedInternalContact && typeof this.selectedInternalContact === 'object');
      },

      resetUsers: function() {
        var foundUser, self = $scope.ordersRequestsEdit;
        if (self.model.orderRequestInternalContact && self.model.orderRequestInternalContact.id) {
          foundUser = self.findUser(self.model.orderRequestInternalContact.id);
        }
        $timeout(function() {
          //reset template selected if no template is chosen
          if (!self.hasSelectedUser()) {
            if (foundUser || self.currentInternalContact) {
              self.selectedInternalContact = !foundUser ? self.currentInternalContact : self.users[foundUser.index];
            } else {
              self.selectedInternalContact = '';
            }
          }
          self.reduceList = false;
        },0);
      },

      searchUsers: function(field) {
        this.searchingUsers = true;
        ApiService.userProxy.list(this.usersGridState.getGridState()).then(function(response) {
          $scope.ordersRequestsEdit.success.searchUsers(response, field);
        }, this.error.searchUsers);
      },

      showMoreResults: function(item) {
        switch(item.field) {
          case 'orders-requests-edit-org': this.filterOrganizations(true, item.field);
            break;
          case 'orders-requests-edit-internal-contact': this.filterUsers(true, item.field);
            break;
        }
      },

      getOrganizations: function() {
        //TODO: made this list searchable
        this.organizationsGridState.updateGridState(1, this.organizationsPageSize, 'name', 'asc');
        ApiService.partners.list(this.organizationsGridState.getGridState()).then(function(response) {
          $scope.ordersRequestsEdit.success.searchOrganizations(response, false);
        }, this.error.getOrganizations);
      },

      getOrganizationContacts: function(orgId) {
        ApiService.organizations.contacts.list($.extend({ organizationId: orgId }, HelpersService.getPaginator())).then(this.success.getOrganizationContacts, this.error.getOrganizationContacts);
      },

      updateNotes: function() {
        //need this, but it can be empty
      },

      updateQuantity: function() {
        var i, ii,
          unscheduledEventsSummary = {
            tickets: 0,
            addons: 0,
            total: 0,
            quantity: 0
          },
          scheduledEventsSummary = {
            tickets: 0,
            addons: 0,
            total: 0,
            quantity: 0
          },
          purchasedEventsSummary = {
            tickets: 0,
            addons: 0,
            total: 0,
            quantity: 0,
            balance: 0
          },
          r = {
            tickets: 0,
            addons: 0
          };

        for (i=0, ii=this.unscheduledEvents.length; i < ii; i++) {
          r.tickets = r.tickets + this.unscheduledEvents[i].totalTickets;
          r.addons = r.addons + this.unscheduledEvents[i].totalAddons;
          unscheduledEventsSummary.tickets = unscheduledEventsSummary.tickets + this.unscheduledEvents[i].totalTickets;
          unscheduledEventsSummary.addons = unscheduledEventsSummary.addons + this.unscheduledEvents[i].totalAddons;
          unscheduledEventsSummary.total = unscheduledEventsSummary.total + HelpersService.currencyFloatToInteger(this.unscheduledEvents[i].subTotal);
        }
        unscheduledEventsSummary.total = HelpersService.integerToCurrencyFloat(unscheduledEventsSummary.total);
        unscheduledEventsSummary.quantity = this.unscheduledEvents.length;

        this.unscheduledEventsSummary = unscheduledEventsSummary;

        for (i=0, ii=this.scheduledEvents.length; i < ii; i++) {
          r.tickets = r.tickets + this.scheduledEvents[i].totalTickets;
          r.addons = r.addons + this.scheduledEvents[i].totalAddons;
          scheduledEventsSummary.tickets = scheduledEventsSummary.tickets + this.scheduledEvents[i].totalTickets;
          scheduledEventsSummary.addons = scheduledEventsSummary.addons + this.scheduledEvents[i].totalAddons;
          scheduledEventsSummary.total = scheduledEventsSummary.total + HelpersService.currencyFloatToInteger(this.scheduledEvents[i].subTotal);
        }
        scheduledEventsSummary.total = HelpersService.integerToCurrencyFloat(scheduledEventsSummary.total);
        scheduledEventsSummary.quantity = this.scheduledEvents.length;

        this.scheduledEventsSummary = scheduledEventsSummary;

        for (i=0, ii=this.purchasedEvents.length; i < ii; i++) {
          r.tickets = r.tickets + this.purchasedEvents[i].totalTickets;
          r.addons = r.addons + this.purchasedEvents[i].totalAddons;
          purchasedEventsSummary.tickets = purchasedEventsSummary.tickets + this.purchasedEvents[i].totalTickets;
          purchasedEventsSummary.addons = purchasedEventsSummary.addons + this.purchasedEvents[i].totalAddons;
          purchasedEventsSummary.total = purchasedEventsSummary.total + HelpersService.currencyFloatToInteger(this.purchasedEvents[i].subTotal);
          purchasedEventsSummary.balance = purchasedEventsSummary.balance + HelpersService.currencyFloatToInteger(this.purchasedEvents[i].balance);
        }
        purchasedEventsSummary.total = HelpersService.integerToCurrencyFloat(purchasedEventsSummary.total);
        purchasedEventsSummary.balance = HelpersService.integerToCurrencyFloat(purchasedEventsSummary.balance);
        purchasedEventsSummary.quantity = this.purchasedEvents.length;

        this.purchasedEventsSummary = purchasedEventsSummary;

        this.totalTickets = r.tickets;
        this.totalAddons = r.addons;

      },

      getLabelForValue: function(list, value) {
        var item, r = 'Unknown';

        list = list instanceof Array ? list : [];
        value = value || '';

        item = list.filter(function(item) {
          return item.value === value;
        });

        if (item.length) {
          r = item[0].label;
        }

        return r;
      },

      getTotalEventCount: function() {
        var r = 0,
            orderItemLength = this.model.orderRequestItems instanceof Array ? this.model.orderRequestItems.length : 0,
            eventLength = 0;
        if (this.unscheduledEvents instanceof Array) {
          eventLength = eventLength + this.unscheduledEvents.length;
        }
        if (this.scheduledEvents instanceof Array) {
          eventLength = eventLength + this.scheduledEvents.length;
        }
        if (this.purchasedEvents instanceof Array) {
          eventLength = eventLength + this.purchasedEvents.length;
        }
        if (orderItemLength || eventLength) {
          r = Math.max(orderItemLength, eventLength);
        }

        return r;
      },

      createOrderRequestItem: function(eventTemplate) {
        return {
          eventTemplateId: eventTemplate.id,
          eventTemplateName: eventTemplate.name,
          eventColorCategory: eventTemplate.colorCategory,
          customFields: eventTemplate.customFields,
          orderRequestItemSummary: {
            total: 0,
            subTotal: 0,
            balance: 0,
            itemDetails: []
          },
          orderItemType: 'Event'
        };
      },

      getOrderRequestItemFromEvent: function(event) {
        var orderRequestItem = {
          eventStartDate: event.eventStartDate,
          eventTemplateId: event.eventTemplateId,
          eventTemplateName: event.eventTemplateName,
          orderRequestItemSummary: event.orderRequestItemSummary,
          externalReferenceId: event.externalReferenceId || '',
          orderItemType: 'Event'
        };

        if (event.id) {
          orderRequestItem.id = event.id;
        }
        if (event.eventId) {
          orderRequestItem.eventId = event.eventId;
        }
        if (event.colorCategory) {
          event.colorCodes = TemplatesHelpersService.getColorCategoryStyle(event.colorCategory);
        }
        if (event.eventName) {
          orderRequestItem.eventName = event.eventName;
        }
        if (event.orderNumber) {
          orderRequestItem.orderNumber = event.orderNumber;
        }
        if (event.orderId) {
          orderRequestItem.orderId = event.orderId;
        }
        if (event.customFields) {
          orderRequestItem.customFields = event.customFields;
        }
        if (event.orderRequestItemId) {
          orderRequestItem.orderRequestItemId = event.orderRequestItemId;
        }

        return orderRequestItem;
      },

      marshalOrderRequest: function() {
        var found;
        if (this.hasSelectedOrganization()) {
          this.model.organizationId = this.selectedOrganization.company.id;
        }
        found = this.model.organizationId ? this.findOrganization(this.model.organizationId) : false;
        if (this.selectedOrderContact) {
          this.model.orderRequestContact = this.selectedOrderContact;
        } else {
          this.model.orderRequestContact = null;
          delete(this.model.orderRequestContact);
        }
        if (this.selectedInternalContact && this.hasSelectedUser()) {
          this.currentInternalContact = this.selectedInternalContact;
          this.model.orderRequestInternalContact = this.selectedInternalContact;
        }else {
          this.model.orderRequestInternalContact = null;
          delete(this.model.orderRequestInternalContact);
        }
        this.model.organizationName = (found && found.organization.company && found.organization.company.name) ? found.organization.company.name : (this.model.organizationName || '');
      },

      marshalOrderRequestItems: function() {
        var i, ii,
            orderRequestItems = [];

        for (i=0, ii=this.unscheduledEvents.length; i < ii; i++) {
          orderRequestItems.push(this.getOrderRequestItemFromEvent(this.unscheduledEvents[i]));
        }
        for (i=0, ii=this.scheduledEvents.length; i < ii; i++) {
          orderRequestItems.push(this.getOrderRequestItemFromEvent(this.scheduledEvents[i]));
        }
        for (i=0, ii=this.purchasedEvents.length; i < ii; i++) {
          orderRequestItems.push(this.getOrderRequestItemFromEvent(this.purchasedEvents[i]));
        }

        this.model.orderRequestItems = orderRequestItems;
      },

      cancel: function() {
        $state.go('application.orders.requests.list');
      },

      create: function() {
        this.marshalOrderRequest();
        if (!this.model.organizationId) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: 'Please select an organization.'
          }]);
        } else {
          ApiService.orders.requests.create(this.model).then(this.success.create, this.error.create);
        }
      },

      update: function() {
        this.marshalOrderRequest();
        this.marshalOrderRequestItems();
        ApiService.orders.requests.update(this.model).then(this.success.update, this.error.update);
      },

      addOrderRequestItem: function(item) {
        ApiService.orders.requests.items.create(this.model.id, item).then(this.success.addOrderRequestItem, this.error.addOrderRequestItem);
      },

      updateOrderRequestItems: function() {
        var i, ii,
          promises = [];
        this.marshalOrderRequestItems();
        for (i=0, ii=this.model.orderRequestItems.length; i < ii; i++) {
          if (this.model.orderRequestItems[i].orderRequestItemId) {
            promises.push(ApiService.orders.requests.items.update(this.model.id, this.model.orderRequestItems[i].orderRequestItemId));
          }
        }

        $q.all(promises).then(this.success.updateOrderRequestItems, this.error.updateOrderRequestItems);
      },

      updateOrderRequestItem: function(item, deleteEvent, successCallback) {
        if (item.orderRequestItemId) {
          ApiService.orders.requests.items.update(this.model.id, item).then(successCallback || this.success.updateOrderRequestItem, function (response) {
            var self = $scope.ordersRequestsEdit;
            if (deleteEvent && PermissionsService.check('EVENT_DELETE') && item.eventId) {
              //remove the created off schedule event or it will be an orphan.
              ApiService.event.removeOffSchedule(item.eventId).then(self.error.updateOrderRequestItem, self.error.updateOrderRequestItem);
            } else {
              self.error.updateOrderRequestItem();
            }
          });
        }
      },

      updateOrderRequestExternalReferenceId: function(item) {
        if (item.orderRequestItemId) {
          ApiService.orders.externalReferenceId({
            orderId: item.orderId,
            eventId: item.eventId,
            externalReferenceId: item.externalReferenceId
          }).then(this.success.updateOrderRequestExternalReferenceId, this.error.updateOrderRequestExternalReferenceId);
        }
      },

      removeOrderRequestItems: function(items) {
        var i, ii,
            promises = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (items[i].orderRequestItemId) {
            promises.push(ApiService.orders.requests.items.remove(this.model.id, items[i].orderRequestItemId));
            if (items[i].eventId) {
              this.deleteOffScheduleEvent(items[i].eventId);
            }
          }
        }

        $q.all(promises).then(this.success.removeOrderRequestItems, this.error.removeOrderRequestItems);
      },

      deleteOffScheduleEvent: function(id) {
        ApiService.event.removeOffSchedule(id).then(this.success.deleteOffScheduleEvent, this.error.deleteOffScheduleEvent);
      },

      checkSelfAssign: function(event) {
        var isSelfAssign = false,
            allowSelfAssign = true;
        if (event.hasOwnProperty('resourceRequestSummary') && event.resourceRequestSummary.hasResourceRequests) {
          if (event.resourceRequestSummary.totalRequestsCount > 0) {
            allowSelfAssign = false;
          }
        }
        if (allowSelfAssign &&
            !PermissionsService.check(['RESOURCES_REQUESTS_ASSIGN']) &&
            (PermissionsService.check(['RESOURCES_REQUESTS_SELF_ASSIGN']) && PermissionsService.check('RESOURCES_REQUESTS_PERSON_CREATE'))) {
          isSelfAssign = true;
        }

        return isSelfAssign;
      },

      getEventRequestsDisplay: function(event) {

        var r = 'No requests',
          personnelRequests = '',
          equipmentRequests = '',
          placesRequests = '';

        if (event.hasOwnProperty('resourceRequestSummary') && event.resourceRequestSummary.hasResourceRequests) {
          personnelRequests = this.getRequestsForCategory(event, 'people');
          equipmentRequests = this.getRequestsForCategory(event, 'equipment');
          placesRequests = this.getRequestsForCategory(event, 'place');

          if (personnelRequests || equipmentRequests || placesRequests) {
            r = (personnelRequests || '');
            if (equipmentRequests) {
              r = r ? (r + ', ' + equipmentRequests) : equipmentRequests;
            }
            if (placesRequests) {
              r = r ? (r + ', ' + placesRequests) : placesRequests;
            }
          }
        }

        return (r === 'No requests') ? '' : r;
      },

      getRequestsForCategory: function(event, category) {
        var categorySuffix,
          fulfilled = 0,
          total = 0,
          requests,
          r = '';

        if (category === 'place') {
          categorySuffix = 'Places';
        }else {
          categorySuffix = HelpersService.cap(category);
        }

        if (event.resourceRequestSummary.hasOwnProperty(category)) {
          fulfilled = event.resourceRequestSummary[category].fulfilledRequestsCount ? event.resourceRequestSummary[category].fulfilledRequestsCount : 0;
          total = event.resourceRequestSummary[category].totalRequestsCount ? (event.resourceRequestSummary[category].totalRequestsCount) : 0;
          requests = (total) ?  (fulfilled + '/' + total) : '';
          // Show resource name if total and fulfilled is 1 and only 1
          if (fulfilled === total && fulfilled === 1) {
            if (event.resourceRequestSummary[category].resourceNames instanceof Array &&
              event.resourceRequestSummary[category].resourceNames[0]) {
              r = event.resourceRequestSummary[category].resourceNames[0];
            }
          }else {
            r = requests ? requests + ' ' + categorySuffix : '';
          }
        }

        return r;
      },

      getEventTicketsDisplay: function(event) {

        var r = {
          display: 'No tickets',
          quantity: {
              tickets: 0,
              addons: 0
            },
          total: 0
          },
          tickets,
          addOns;

        if (event.hasOwnProperty('orderRequestItemSummary') && event.orderRequestItemSummary &&
            (event.orderRequestItemSummary.hasOwnProperty('itemDetails')) && (event.orderRequestItemSummary.itemDetails instanceof Array)) {

          r.total = HelpersService.integerToCurrencyFloat(event.orderRequestItemSummary.total);

          tickets = this.geTicketDisplayForType(event, 'tickets');
          addOns = this.geTicketDisplayForType(event, 'addons');

          r.quantity.tickets = tickets.quantity;
          r.quantity.addons = addOns.quantity;

          if (tickets.display || addOns.display) {
            r.display = (tickets.display || '');
            if (addOns.display) {
              r.display = r.display ? (r.display + ', ' + addOns.display) : addOns.display;
            }
          }
        }

        return (r.display === 'No tickets') ? {
          display: '',
          quantity: {
            tickets: 0,
            addons: 0
          }
        } : r;
      },

      geTicketDisplayForType: function(event, type) {
        var r = {
              display: '',
              quantity: 0
            },
            item,
            i, ii,
            eventsOfType = this.getOrderRequestItemsOfType(event, type);

        for (i=0, ii=eventsOfType.length; i < ii; i++) {
          item = eventsOfType[i];
          r.display = r.display + (item.itemTypeName ? (item.itemTypeName) + ': ' : '') + item.quantity + '@' + $filter('currency')(item.unitPrice);
          r.quantity = r.quantity + item.quantity;
          if (i+1 < eventsOfType.length) {
            r.display = r.display + ', ';
          }
        }

        return r;
      },

      getOrderRequestItemsOfType: function(event, type) {
        var r = [],
            isAddOnType,
            i, ii;
        if (type && event && event.orderRequestItemSummary && event.orderRequestItemSummary.itemDetails instanceof Array) {
          isAddOnType = (type === 'addons');
          for (i=0, ii=event.orderRequestItemSummary.itemDetails.length; i < ii; i++) {
            if (event.orderRequestItemSummary.itemDetails[i].addon === isAddOnType ||
              (event.orderRequestItemSummary.itemDetails[i].isAddon === isAddOnType)) {
              r.push(event.orderRequestItemSummary.itemDetails[i]);
            }
          }
        }

        return r;
      },

      processOrderRequest: function(orderRequest) {
        var i, ii;
        if (orderRequest.orderRequestItems instanceof Array) {
          for (i=0, ii=orderRequest.orderRequestItems.length; i < ii; i++) {
            this.processOrderRequestItem(orderRequest.orderRequestItems[i]);
          }
        }
        this.selectedOrderContact = orderRequest.orderRequestContact || "";
        if (this.selectedOrderContact) {
          this.selectedOrderContact.name = this.getContactDisplayName(orderRequest.orderRequestContact);
        }
        this.selectedInternalContact = orderRequest.orderRequestInternalContact || "";
        if (this.selectedInternalContact) {
          this.selectedInternalContact.name = this.getContactDisplayName(orderRequest.orderRequestInternalContact);
        }
        if (orderRequest.updatedOn) {
          orderRequest.formattedLastModified = $filter('date')(orderRequest.updatedOn, this.timeStampDateFormat) + ' at ' +  $filter('date')(orderRequest.updatedOn, this.timeStampHourFormat);
        }
        if (orderRequest.createdOn) {
          orderRequest.formattedDateCreated = $filter('date')(orderRequest.createdOn, this.timeStampDateFormat) + ' at ' +  $filter('date')(orderRequest.createdOn, this.timeStampHourFormat);
        }

        this.isTaxExempt = !!orderRequest.isTaxExempt;

        return orderRequest;
      },

      processOrderRequestItem: function(item) {
        var i, ii,
            itemDetailSummary = this.getEventTicketsDisplay(item),
            found;

        item.ticketsDisplay = itemDetailSummary.display;
        item.totalTickets = itemDetailSummary.quantity.tickets;
        item.totalAddons = itemDetailSummary.quantity.addons;

        if (item.eventColorCategory &&
            item.eventColorCategory.textColor &&
            item.eventColorCategory.backgroundColor) {
          item.colorCategoryStyle = TemplatesHelpersService.getColorCategoryStyle(item.eventColorCategory);
        }
        item.allowTicketEdit = !this.isRestrictedUser;
        item.subTotal = item.orderRequestItemSummary ? item.orderRequestItemSummary.subTotal || 0 : 0;
        item.balance = item.orderRequestItemSummary ? item.orderRequestItemSummary.balance || 0 : 0;

        for (i=0, ii=this.customFields.length; i < ii; i++) {
          item[this.customFields[i].internalLabel] = HelpersService.getCustomFieldValue(item, this.customFields[i].label);
        }

        if (item.eventId && item.orderNumber) {
          found = this.findEventByOrderRequestItemId(this.purchasedEvents, item.orderRequestItemId);
          if (found) {
            this.purchasedEvents[found.index] = item;
          } else {
            this.purchasedEvents.push(item);
          }
        } else if (item.eventId) {
          item.resourceRequestDisplay = this.getEventRequestsDisplay(item);
          item.isSelfAssign = this.checkSelfAssign(item);
          found = this.findEventByOrderRequestItemId(this.scheduledEvents, item.orderRequestItemId);
          if (found) {
            this.scheduledEvents[found.index] = item;
          } else {
            this.scheduledEvents.push(item);
          }
        } else{
          found = this.findEventByOrderRequestItemId(this.unscheduledEvents, item.orderRequestItemId);
          if (found) {
            this.unscheduledEvents[found.index] = item;
          } else {
            this.unscheduledEvents.push(item);
          }
        }

        this.updateQuantity();

        return item;
      },

      processOrderRequestItemDetail: function(item) {
        var itemDetailSummary = this.getEventTicketsDisplay(item);
        item.ticketsDisplay = itemDetailSummary.display;
        item.totalTickets = itemDetailSummary.quantity.tickets;
        item.totalAddons = itemDetailSummary.quantity.addons;

        if (item.eventId) {
          item.resourceRequestDisplay = this.getEventRequestsDisplay(item);
          item.subTotal = item.orderRequestItemSummary ? item.orderRequestItemSummary.subTotal || 0 : 0;
        }

        this.updateQuantity();

        return item;
      },
      
      findItem: function(list, id) {
        var i, ii, r = false;
        for (i=0, ii=list.length; i < ii; i++) {
          if (list[i].id === id) {
            r = {
              index: i,
              item: list[i]
            };
            break;
          }
        }

        return r;
      },

      findEventByOrderRequestItemId: function(list, orderRequestItemId) {
        var i, ii, r = false;
        if (list instanceof Array && orderRequestItemId) {
          for (i=0, ii=list.length; i < ii; i++) {
            if (list[i].orderRequestItemId === orderRequestItemId) {
              r = {
                index: i,
                item: list[i]
              };
              break;
            }
          }
        }

        return r;
      },

      findEventType: function(event) {
        var r = false;

        if (event.eventId && event.orderNumber) {
          r = {
            type: 'purchased',
            id: event.eventId
          };
        } else if (event.eventId) {
          r = {
            type: 'scheduled',
            id: event.eventId
          };
        } else {
          r = {
            type: 'unscheduled',
            id: event.orderRequestItemId
          };
        }

        return r;
      },

      hasSelectedEvents: function(type) {
        return this.getSelectedEventsForType(type).length;
      },

      clearSelection: function() {
        this.selectedEvents = {};
        this.unscheduledEventsGridDefinition.clearSelection();
        this.scheduledEventsGridDefinition.clearSelection();
        this.purchasedEventsGridDefinition.clearSelection();
      },

      getSelectedEventsForType: function(type) {
        var r = [], id;

        for (id in this.selectedEvents) {
          if (this.selectedEvents.hasOwnProperty(id)) {
            if (this.selectedEvents[id].type === type && this.selectedEvents[id].selected) {
              r.push(this.selectedEvents[id].data);
            }
          }
        }

        return r;
      },

      processContacts: function(contacts) {
        var found;

        for (i=0, ii=contacts.length; i < ii; i++) {
          contacts[i].name = this.getContactDisplayName(contacts[i]);
        }

        this.setOrderContact(contacts);

        return contacts;
      },

      setOrderContact: function(contacts) {
        if (this.model.orderRequestContact && this.model.orderRequestContact.id) {
          found = this.findItem(contacts, this.model.orderRequestContact.id);
          if (found) {
            this.selectedOrderContact = found.item;
          }
        }
      },

      processUsers: function(users) {
        var i, ii;

        for (i=0, ii=users.length; i < ii; i++) {
          users[i].name = this.getContactDisplayName(users[i]);
        }

        return users;
      },

      getOrderRequestItem: function(orderRequestItemId, type) {
        ApiService.orders.requests.items.detail(this.model.id, orderRequestItemId).then(function(response) {
          var self = $scope.ordersRequestsEdit,
              found;
          if (type === 'scheduled') {
            self.processOrderRequestItem(response.data.payload);
          }else if (type === 'unscheduled') {
            self.processOrderRequestItem(response.data.payload);
          }
        }, function() {});
      },

      showAddEventsModal: function() {
        var self = $scope.ordersRequestsEdit;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/orders/modals/request/request.tpl.html',
          size: 'lg',
          controller: 'OrdersModalsRequestController',
          resolve: {
            customFields: function () {
              return CustomFieldsData.data.success ? CustomFieldsData.data.payload.list : [];
            },
            eventTemplates: function () {
              return [];
            }
          }
        });

        self.showModal.result.then(function (selectedEventTemplates) {
          var i, ii,
              orderRequestItem;
          for (i=0, ii=selectedEventTemplates.length;i < ii; i++) {
            orderRequestItem = self.createOrderRequestItem(selectedEventTemplates[i]);
            self.addOrderRequestItem(orderRequestItem);
          }
        }, function () {
        });
      },

      showScheduleEventModal: function(row, type) {
        var self = $scope.ordersRequestsEdit,
            event = row && row.entity;

        //For templates, we need to create an unscheduled event, so the user needs to have the permission to do it.
        // For events, we need to update the event, so the user needs to have the owner_view permission to do it.
        if ((type !== 'scheduled') || (self.isRestrictedUser || PermissionsService.check('EVENT_UPDATE'))) {

          self.scheduleEventModal = $uibModal.open({
            templateUrl: 'views/application/views/orders/requests/modals/scheduleEvent/scheduleEvent.tpl.html',
            size: 'md',
            controller: 'OrdersRequestsModalsScheduleEventController',
            resolve: {
              SelectedEvents: function() {
                var selectedEvents = [];
                if (event) {
                  selectedEvents = [event];
                } else {
                  if (type && type === 'unscheduled') {
                    selectedEvents = self.getSelectedEventsForType('unscheduled');
                  } else {
                    selectedEvents = self.getSelectedEventsForType('scheduled');
                  }
                }
                return selectedEvents;
              },
              IsTemplate: function() {
                return (type && type === 'unscheduled');
              },
              OrderRequestId: function() {
                return self.model.id;
              }
            }
          });

          self.scheduleEventModal.result.then(function(response) {
            var i, ii,
              found,
              event;
            if (response && response.event) {
              if (type && type === 'scheduled') {
                found = self.findEventByOrderRequestItemId(self.scheduledEvents, response.event.orderRequestItemId);
                if (found) {
                  //update the event
                  event = self.getOrderRequestItemFromEvent(response.event);
                  self.updateOrderRequestItem(event, false, function(response) {
                    self.processOrderRequestItem(response.data.payload);
                  });
                }
              } else if (type && type === 'unscheduled') {
                found = self.findEventByOrderRequestItemId(self.unscheduledEvents, response.event.orderRequestItemId);
                if (found) {
                  //remove from unscheduled and add to scheduled events
                  event = self.getOrderRequestItemFromEvent(response.event);
                  self.updateOrderRequestItem(event, true, function(response) {
                    self.unscheduledEvents.splice(found.index, 1);
                    self.processOrderRequestItem(response.data.payload);
                    $timeout(function() {
                      $scope.$broadcast('DataGrid::ResizeGrid', {name: self.scheduledEventsGridDefinition.options.gridName, datasetLength: self.scheduledEvents.length, totalItems: self.scheduledEvents.length});
                      $scope.$broadcast('DataGrid::ResizeGrid', {name: self.unscheduledEventsGridDefinition.options.gridName, datasetLength: self.unscheduledEvents.length, totalItems: self.unscheduledEvents.length});
                    }, 10);
                  });
                }
              }
            }
            self.clearSelection();
          }, function() {
            //do nothing
          });
        }

      },

      showRescheduleEventModal: function(row) {
        var self = $scope.ordersRequestsEdit,
          entity = row && row.entity;

        if (self.isRestrictedUser || PermissionsService.check('EVENT_RESCHEDULE')) {
          ApiService.program.times.detail(entity.eventId).then(function(response) {
            var event = response.data.payload;

            self.rescheduleEventModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/modals/rescheduleEvent/rescheduleEvent.tpl.html',
              size: 'md',
              controller: 'ProgramsModalsRescheduleEventController',
              resolve: {
                eventInstance : function () {
                  return event;
                },
                resourcesCount: function () {
                  var r = 0;
                  if (entity.hasOwnProperty('resourceRequestSummary') && entity.resourceRequestSummary.hasResourceRequests) {
                    r = entity.resourceRequestSummary.totalRequestsCount;
                  }
                  return r;
                }
              }
            });

            self.rescheduleEventModal.result.then(function (rescheduledEvent) {
              ApiService.program.times.update(rescheduledEvent).then(self.success.rescheduleEvent, self.error.rescheduleEvent);
            });
          }, function(response) {
            $scope.ordersRequestsEdit.notice.showErrorMessages([{
              message: response.data.error
            }]);
          });
        }
      },

      showTicketsModal: function(row, type) {
        var self = $scope.ordersRequestsEdit,
          event = row && row.entity;

        if (!self.isRestrictedUser) {

          self.ticketsModal = $uibModal.open({
            templateUrl: 'views/application/views/orders/requests/modals/tickets/tickets.tpl.html',
            size: 'lg',
            controller: 'OrdersRequestsModalsTicketsController',
            resolve: {
              SelectedEvents: function () {
                var selectedEvents = [];
                if (event) {
                  selectedEvents = [event];
                } else {
                  if (type && type === 'unscheduled') {
                    selectedEvents = self.getSelectedEventsForType('unscheduled');
                  } else {
                    selectedEvents = self.getSelectedEventsForType('scheduled');
                  }
                }
                return selectedEvents;
              },
              IsTemplate: function () {
                return (type && type === 'unscheduled');
              },
              OrderRequestId: function() {
                return self.model.id;
              }
            }
          });

          self.ticketsModal.result.then(function (response) {
            var i, ii,
              found;
            if (response && response.events instanceof Array) {
              for (i = 0, ii = response.events.length; i < ii; i++) {
                if (type && type === 'scheduled') {
                  found = self.findEventByOrderRequestItemId(self.scheduledEvents, response.events[i].orderRequestItemId);
                  if (found) {
                    //update the event
                    self.scheduledEvents[found.index] = self.processOrderRequestItemDetail(response.events[i]);
                    if (response.events[i].orderRequestItemId) {
                      self.getOrderRequestItem(response.events[i].orderRequestItemId, type);
                    }
                  }
                } else if (type && type === 'unscheduled') {
                  found = self.findEventByOrderRequestItemId(self.unscheduledEvents, response.events[i].orderRequestItemId);
                  if (found) {
                    //update the event
                    self.unscheduledEvents[found.index] = self.processOrderRequestItemDetail(response.events[i]);
                    if (response.events[i].orderRequestItemId) {
                      self.getOrderRequestItem(response.events[i].orderRequestItemId, type);
                    }
                  }
                }

              }
            }
            self.clearSelection();
          }, function () {
            //do nothing
          });
        }
      },

      removeSelectedEvent: function(type) {
        this.showRemoveEventModal(undefined, type);
      },

      showRemoveEventModal: function(row, type) {
        var self = $scope.ordersRequestsEdit;

        if (!self.isRestrictedUser) {

          self.removeEvent = $uibModal.open({
            templateUrl: 'views/application/views/orders/requests/modals/removeEvent/removeEvent.tpl.html',
            size: 'md',
            controller: 'OrdersRequestsModalsRemoveEventController',
            resolve: {
              SelectedEvents: function () {
                var selectedEvents = [];
                if (type && type === 'unscheduled') {
                  selectedEvents = self.getSelectedEventsForType('unscheduled');
                } else {
                  selectedEvents = self.getSelectedEventsForType('scheduled');
                }
                return selectedEvents;
              },
              IsTemplate: function () {
                return (type && type === 'unscheduled');
              }
            }
          });

          self.removeEvent.result.then(function (events) {
            var i, ii,
              found,
              orderRequestItems = [];
            if (events instanceof Array) {
              for (i = 0, ii = events.length; i < ii; i++) {
                if (type && type === 'scheduled') {
                  found = self.findEventByOrderRequestItemId(self.scheduledEvents, events[i].orderRequestItemId);
                  if (found) {
                    if (found.item.orderRequestItemId) {
                      orderRequestItems.push(found.item);
                    }
                    self.scheduledEvents.splice(found.index, 1);
                  }
                } else if (type && type === 'unscheduled') {
                  found = self.findEventByOrderRequestItemId(self.unscheduledEvents, events[i].orderRequestItemId);
                  if (found) {
                    if (found.item.orderRequestItemId) {
                      orderRequestItems.push(found.item);
                    }
                    self.unscheduledEvents.splice(found.index, 1);
                  }
                }

              }
              self.removeOrderRequestItems(orderRequestItems);
              self.clearSelection();
            }
          }, function () {
            //do nothing
          });
        }
      },

      showResourceTypesModal: function(types, selectedEvent) {
        var self = $scope.ordersRequestsEdit;
        self.selectResourceTypeModal = $uibModal.open({
          templateUrl: 'views/application/views/orders/requests/modals/selectResourceType/selectResourceType.tpl.html',
          size: 'md',
          controller: 'OrdersRequestsModalsSelectResourceTypeController',
          resolve: {
            Types: function () {
              return types;
            }
          }
        });

        self.selectResourceTypeModal.result.then(function (type) {
          if (type) {
            self.assignResourceType(type, selectedEvent);
          }
        }, function () {
          //do nothing
        });
      },

      getTypesForResource: function(resourceCategory, selectedEvent) {
        var user = AuthService.getCookie('user'),
            search = '';
        if (user && user.id) {
          search = user.firstName ? (user.firstName + (user.lastName ? ' ' + user.lastName : '')) :
                                    (user.lastName ? user.lastName : '');
        }
        if (search) {
          ApiService.resource.instances.filterList($.extend({
            category: resourceCategory,
            search: search
          }, HelpersService.getPaginator())).then(function(response) {
            $scope.ordersRequestsEdit.success.getTypesForResource(response, selectedEvent);
          }, this.error.getTypesForResource);
        } else {
          this.error.getTypesForResource({
            data: {
              error: 'Unable to assign as you are not a resource in the system.'
            }
          });
        }
      },

      getTicketsForEvent: function(event) {
        var i, ii,
          items = event.orderRequestItemSummary.itemDetails instanceof Array ? event.orderRequestItemSummary.itemDetails : [],
          prices = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (!items[i].addon && !items[i].isAddon) {
            items[i].personType = {
              id: items[i].itemTypeId,
              name: items[i].itemTypeName
            };
            items[i].price = items[i].unitPrice;
            items[i].discountedPrice = items[i].discountedUnitPrice;
            items[i].salesChannels = [
              {
                "name":"Web",
                "channel":"online",
                "enabled":true
              },
              {
                "name":"Customer Rep",
                "channel":"customerRep",
                "enabled":true
              },
              {
                "name":"Point of Sale",
                "channel":"pointOfSale",
                "enabled":false
              },
              {
                "name":"Manual Entry",
                "channel":"manualEntry",
                "enabled":false
              },
              {
                "name":"Reseller",
                "channel":"reseller",
                "enabled":false
              }
            ];
            prices.push(items[i]);
          }
        }
        return prices;
      },

      getAddOnsForEvent: function(event) {
        var i, ii,
          items = event.orderRequestItemSummary.itemDetails instanceof Array ? event.orderRequestItemSummary.itemDetails : [],
          addOns = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (items[i].addon || items[i].isAddon) {
            items[i].id = items[i].itemTypeId;
            items[i].name = items[i].itemTypeName;
            items[i].price = items[i].unitPrice;
            items[i].discountedPrice = items[i].discountedUnitPrice;
            items[i].totalQuantity = items[i].quantity;
            items[i].salesChannels = [
              {
                "name":"Web",
                "channel":"online",
                "enabled":true
              },
              {
                "name":"Customer Rep",
                "channel":"customerRep",
                "enabled":true
              },
              {
                "name":"Point of Sale",
                "channel":"pointOfSale",
                "enabled":false
              },
              {
                "name":"Manual Entry",
                "channel":"manualEntry",
                "enabled":false
              },
              {
                "name":"Reseller",
                "channel":"reseller",
                "enabled":false
              }
            ];
            addOns.push(items[i]);
          }
        }
        return addOns;
      },

      editTickets: function(type) {
        this.showTicketsModal(undefined, type);
      },

      createOrder: function() {
        var self = $scope.ordersRequestsEdit,
            selectedEvents = self.getSelectedEventsForType('scheduled'),
            events = [];

        selectedEvents.forEach(function(selectedEvent) {
          var event = {};
          event.priceList = {
            prices: self.getTicketsForEvent(selectedEvent)
          };
          event.addOns = {
            inventoryAddOns: self.getAddOnsForEvent(selectedEvent)
          };
          event.eventStartDate = selectedEvent.eventStartDate;
          event.colorCategory = selectedEvent.eventColorCategory;
          event.externalReferenceId = selectedEvent.externalReferenceId;
          event.orderRequestItemId = selectedEvent.orderRequestItemId;
          event.id = selectedEvent.eventId;
          event.name = selectedEvent.eventName;
          event.ticketDetails = {
            ticketDurationDays: 1
          };
          events.push(event);
        });

        events = events.sort(function(a, b) {
          var aDate = CalendarService.parseDate(a.eventStartDate).getTime(),
              bDate = CalendarService.parseDate(b.eventStartDate).getTime(),
              r = 0;

          if (!isNaN(aDate) && !isNaN(bDate)) {
            if(aDate > bDate) {
              r = 1;
            } else if(aDate < bDate) {
              r = -1;
            }
          }

          return r;

        });

        OrderService.init();
        OrderService.clear();
        OrderService.store({
          orderRequest: {
            id: self.model.id,
            orderRequestItems: events
          }
        });
        $state.go('application.orders.checkout', { accountId: self.model.organizationId });
      },

      viewOrder: function(row) {
        if (PermissionsService.check('ORDER_VIEW')) {
          $state.go('application.orders.detail.summary', {orderId: row.entity.orderId});
        }
      },

      viewEvent: function(row) {
        if (PermissionsService.check('EVENT_VIEW')) {
          $state.go('application.programsInstance', {id: row.entity.eventId});
        }
      },

      viewEventTemplate: function(row) {
        if (PermissionsService.check('EVENT_TEMPLATE_VIEW')) {
          $state.go('application.programsDetail.overview', {id: row.entity.eventTemplateId});
        }
      },

      assignResource: function(row) {
        if (row.entity.isSelfAssign) {
          //first get the resource types for the event
          this.getTypesForResource('personnel', row.entity);
        }
      },

      marshalResourceRequest: function(type) {
        var request = {
          resourceTimeFrame: {
            start: {
              timeFrame: "when",
              allocation: "every",
              type: "starts",
              duration: {
                hour: 1,
                minutes: 0
              }
            },
            end: {
              timeFrame: "when",
              allocation: "every",
              type: "ends",
              duration: {
                hour: 1,
                minutes: 0
              }
            }
          },
          eventResource: {
            type: type.resourceTemplateName,
            resourceId: type.id,
            resourceTemplateId: type.resourceTemplateId,
            quantity: 1,
            values: [],
            resourceCategory: "personnel",
            resourceTemplateName: type.resourceTemplateName,
            resourceName: type.name
          },
          notes: ""
        };

        return request;
      },

      assignResourceType: function(type, selectedEvent) {
        var props = this.marshalResourceRequest(type);

        if (!props.id) {
          props.id = selectedEvent.eventId;
          ApiService.program.resources.instance.create(props).then(function(response) {
            $scope.ordersRequestsEdit.success.assignResourceType(response, selectedEvent);
          }, this.error.assignResourceType);
        }
      },

      createRequest: function() {

        var props;

        if (this.isType('instance')) {

          props = $.extend({
            id: schedule.id
          }, this.model);

          ApiService.program.resources.instance.create(props).then(this.success.updateRequest, this.error.updateRequest);

        }else if (this.isType('template')) {

          props = $.extend({
            templateId: templateId,
            scheduleId: schedule.id
          }, this.model);

          ApiService.program.resources.schedule.create(props).then(this.success.createRequest, this.error.createRequest);

        }

      },

      findOrganization: function(id) {
        var i, ii,
            r = false;
        for (i=0, ii=this.organizations.length; i < ii; i++) {
          if (this.organizations[i].company && (this.organizations[i].company.id === this.model.organizationId)) {
            r = {
              index: i,
              organization: this.organizations[i]
            };
            break;
          }
        }
        return r;
      },

      findUser: function(id) {
        var i, ii,
            r = false;
        for (i=0, ii=this.users.length; i < ii; i++) {
          if (this.users[i].id === this.model.orderRequestInternalContact.id) {
            r = {
              index: i,
              user: this.users[i]
            };
            break;
          }
        }
        return r;
      },

      processOrganizations: function() {
        var found;
        if (this.model.organizationId && this.organizations instanceof Array && this.organizations.length) {
          found = this.findOrganization(this.model.organizationId);
          if (!found) {
            this.model.organizationId = false;
            this.selectedOrganization = '';
          } else {
            this.currentOrganization = found.organization;
            this.selectedOrganization = found.organization;
          }
        }

      },

      processSearchResults: function(list, count, gridState, pageSize, showMore) {
        var r = list,
          currentCount = (this[gridState].gridState.page || 1) * this[gridState].gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this[showMore] = {
            showMoreLabel: 'Show '+ pageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this[showMore] = {
            showMoreLabel: '',
            hasMore: false
          };
        }
        return r;
      },
      
      findPaymentStatus: function (status) {
        var res =  $scope.ordersRequestsEdit.paymentStatusTypes.filter(function (val) {
          return (val.value === status);
        });

        return (res && res.length > 0 && res[0].label) ? res[0].label : '';
      },

      findEventState: function (state) {
        var res =  $scope.ordersRequestsEdit.eventStateTypes.filter(function (val) {
          return (val.value === state);
        });
        return (res && res.length > 0 && res[0].label) ? res[0].label : '';
      },

      comboboxSearchOrganizations: function(search){
        var props = this.organizationsGridState.getGridState();
        props.pageSize = this.organizationsPageSize;
        props.organizationName = search;
        props.sortField = 'organizationName';
        ApiService.organizations.searchOrganizations(props).then(function(res) {
            $scope.ordersRequestsEdit.comboboxOrganizations = res.data.payload.list.map(function(item) {
              item.name = item.organizationName;
              return item;
            });
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: 'combobox-input-' + 'orders-request-edit-organizations'});
        });
      },

      success: {
        init: function(response) {
          var self = $scope.ordersRequestsEdit;
          self.model = self.processOrderRequest(response.data.payload);
          self.unscheduledEventsGridDefinition.isLoaded = true;
          self.scheduledEventsGridDefinition.isLoaded = true;
          self.purchasedEventsGridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.unscheduledEventsGridDefinition.options.gridName, datasetLength: self.unscheduledEvents.length, totalItems: self.unscheduledEvents.length});
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.scheduledEventsGridDefinition.options.gridName, datasetLength: self.scheduledEvents.length, totalItems: self.scheduledEvents.length});
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.purchasedEventsGridDefinition.options.gridName, datasetLength: self.purchasedEvents.length, totalItems: self.purchasedEvents.length});
          }, 20);
        },

        update: function(response) {
          var self = $scope.ordersRequestsEdit;

          self.model = self.processOrderRequest(response.data.payload);

          self.setOrderContact(self.organizationContacts);

          self.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          if ($scope.noticeTimer) {
            $timeout.cancel($scope.noticeTimer);
          }
          $scope.noticeTimer = $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        addOrderRequestItem: function(response) {
          var self = $scope.ordersRequestsEdit;
          //add to the scheduledEvent list
          self.processOrderRequestItem(response.data.payload);
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.unscheduledEventsGridDefinition.options.gridName, datasetLength: self.unscheduledEvents.length, totalItems: self.unscheduledEvents.length});
          }, 10);
        },

        updateOrderRequestItems: function(response) {
          var self = $scope.ordersRequestsEdit;

          self.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          if ($scope.noticeTimer) {
            $timeout.cancel($scope.noticeTimer);
          }
          $scope.noticeTimer = $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        updateOrderRequestItem: function(response) {
          var self = $scope.ordersRequestsEdit;

          if (response.data.payload.orderRequestItemId) {
            self.processOrderRequestItem(response.data.payload);
          }

          if (response.data.payload.orderId) {
            self.updateOrderRequestExternalReferenceId(response.data.payload);
          } else {
            self.notice.showSuccessMessages([{
              message: 'Successfully Saved!'
            }]);

            if ($scope.noticeTimer) {
              $timeout.cancel($scope.noticeTimer);
            }
            $scope.noticeTimer = $timeout(function() {
              self.notice.hideSuccessMessages();
            }, 3000);
          }
        },

        removeOrderRequestItems: function(response) {
          var self = $scope.ordersRequestsEdit;

          self.updateQuantity();

          self.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          if ($scope.noticeTimer) {
            $timeout.cancel($scope.noticeTimer);
          }
          $scope.noticeTimer = $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        deleteOffScheduleEvent: function(response) {},

        create: function(response) {
          if (response.data.payload.id) {
            $state.go('application.orders.requests.edit', {id: response.data.payload.id});
          }
        },

        getUsers: function(response) {
          var self = $scope.ordersRequestsEdit,
              users,
              found;
          users = self.processSearchResults(response.data.payload.list, response.data.payload.pagination.count, 'usersGridState', self.usersPageSize, 'showMoreUsers');
          self.users = self.processUsers(users);
          if (self.model.orderRequestInternalContact && self.model.orderRequestInternalContact.id) {
            found = self.findItem(self.users, self.model.orderRequestInternalContact.id);
            if (!found) {
              self.selectedInternalContact = self.model.orderRequestInternalContact;
              self.currentInternalContact = self.model.orderRequestInternalContact;
            } else {
              self.currentInternalContact = found.item;
              self.selectedInternalContact = found.item;
            }
          }
        },

        getOrganizations: function(response) {
          var self = $scope.ordersRequestsEdit;
          self.organizations = self.processSearchResults(response.data.payload.list, response.data.payload.pagination.count, 'organizationsGridState', self.organizationsPageSize, 'showMoreOrganizations');
          self.processOrganizations();
          if (self.model.organizationId) {
            self.getOrganizationContacts(self.model.organizationId);
          }
        },

        getOrganizationContacts: function(response) {
          var self = $scope.ordersRequestsEdit;
          self.organizationContacts = self.processContacts(response.data.payload.list);
        },

        getTypesForResource: function(response, selectedEvent) {
          var self = $scope.ordersRequestsEdit,
              types = response.data.payload.list;
          if (types instanceof Array) {
            if (types.length > 1) {
              //show modal to select the template type;
              self.showResourceTypesModal(types, selectedEvent);
            } else if (types.length){
              //assign to the only type available.
              self.assignResourceType(types[0], selectedEvent);
            } else {
              self.error.getTypesForResource({
                data: {
                  error: 'Unable to assign as you are not a resource in the system.'
                }
              });
            }
          }
        },

        assignResourceType: function(response, selectedEvent) {
          // processOrderRequestItemDetail
          var self = $scope.ordersRequestsEdit,
              found = self.findEventByOrderRequestItemId(self.scheduledEvents, selectedEvent.orderRequestItemId);
          if (found) {
            self.updateOrderRequestItem(found.item, false);
          }
        },

        searchOrganizations: function(response, field) {
          var self = $scope.ordersRequestsEdit;
          self.organizations = self.processSearchResults(response.data.payload.list, response.data.payload.pagination.count, 'organizationsGridState', self.organizationsPageSize, 'showMoreOrganizations');
          self.processOrganizations();
          self.searchingOrganizations = false;
          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }

        },

        searchUsers: function(response, field) {
          var self = $scope.ordersRequestsEdit,
              users;
          users = self.processSearchResults(response.data.payload.list, response.data.payload.pagination.count, 'usersGridState', self.usersPageSize, 'showMoreUsers');
          self.users = self.processUsers(users);
          self.searchingUsers = false;
          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }
        },

        updateOrderRequestExternalReferenceId: function(response) {
          var self = $scope.ordersRequestsEdit;
          self.notice.showSuccessMessages([{
            message: 'Successfully Saved!'
          }]);

          if ($scope.noticeTimer) {
            $timeout.cancel($scope.noticeTimer);
          }
          $scope.noticeTimer = $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        rescheduleEvent: function(response) {
          var self = $scope.ordersRequestsEdit;
          self.purchasedEventsGridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.purchasedEventsGridDefinition.options.gridName, datasetLength: self.purchasedEvents.length, totalItems: self.purchasedEvents.length});
          }, 20);
        }

      },

      error: {
        init: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        update: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        addOrderRequestItem: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        updateOrderRequestItems: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        updateOrderRequestItem: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        removeOrderRequestItems: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        deleteOffScheduleEvent: function(response) {},
        create: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        getTypesForResource: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        assignResourceType: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        getUsers: function(response) {},
        getOrganizations: function(response) {},
        getOrganizationContacts: function(response) {},
        searchOrganizations: function(response) {
          var self = $scope.ordersRequestsEdit;

          self.organizations = [];
          self.searchingOrganizations = false;
        },
        searchUsers: function(response) {
          var self = $scope.ordersRequestsEdit;

          self.users = [];
          self.searchingUsers = false;
        },
        updateOrderRequestExternalReferenceId: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        rescheduleEvent: function(response) {
          $scope.ordersRequestsEdit.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      onDataGridSelectionChange: function(row, e) {
        var i, ii,
          found,
          self = $scope.ordersRequestsEdit;
        found = self.findEventType(row.entity);
        if (found) {
          self.selectedEvents[found.id] = { selected: row.isSelected, type: found.type, data: row.entity };
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        }
      },

      onSelectedOrganizationChanged: function(n, o) {
        var self = $scope.ordersRequestsEdit;
        if (n !== o) {
          if (self.hasSelectedOrganization()){
            self.currentOrganization = self.selectedOrganization;
            self.getOrganizationContacts(self.selectedOrganization.company.id);
          }
        }
      },

      onSelectedUserChanged: function(n, o) {
        var self = $scope.ordersRequestsEdit;
        if (n !== o) {
          if (self.hasSelectedUser()){
            self.currentInternalContact = self.selectedInternalContact;
          }
        }
      },

      onExternalReferenceIdEdited: function(item) {
        var found,
            self = $scope.ordersRequestsEdit,
            event;
        if (item.orderRequestItemId) {
          event = self.getOrderRequestItemFromEvent(item);
          self.updateOrderRequestItem(event, false);
        }
      },

      onComboboxOrganizationChange: function(){
        this.comboboxSelectedOrganization.id = this.comboboxSelectedOrganization.organizationId;
        this.comboboxSelectedOrganization.company = Object.assign({}, this.comboboxSelectedOrganization);
        this.selectedOrganization = this.comboboxSelectedOrganization;
      },

    };

    $scope.ordersRequestsEdit.init();

}]);
